import { JSX, Show } from 'solid-js';
import { ErrorCatcher } from '../../tools/error-catcher';
import { EyebrowProps } from './eyebrow-types';
import clsx from 'clsx';

interface EyebrowComponent {
    (props: EyebrowProps): JSX.Element;
    parseProps?: (atts: EyebrowProps) => EyebrowProps;
}

export const Eyebrow: EyebrowComponent = (props: EyebrowProps) => {
    const displayLabel = () => {
        if (!props.label) {
            return props.label;
        }
        return props.label;
    };

    return (
        <ErrorCatcher componentName="Eyebrow">
            <Show when={props.label}>
                <div class={clsx('flex items-center gap-cvi-3', props.removeMarginBottom ? 'mb-0' : 'mb-cvi-6')}>
                    <span
                        class="size-2.5 rounded-cvi-round bg-cvi-fg-brand shrink-0"
                        aria-hidden="true"
                    />
                    <span
                        class="body-sm font-cvi-medium text-cvi-fg-default"
                        innerHTML={displayLabel()}
                    />
                </div>
            </Show>
        </ErrorCatcher>
    );
};

/** Maps the WP `atos/eyebrow` block attributes to component props. */
Eyebrow.parseProps = (atts: EyebrowProps): EyebrowProps => ({
    label: atts?.label,
});

export default Eyebrow;
